import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import TextInput from 'components/TextInput'

import { color } from 'styles/colors'

const propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape),
  getOptionLabel: PropTypes.func.isRequired,
  getOptionKey: PropTypes.func.isRequired,
  label: PropTypes.string,
  initialValue: PropTypes.string,
  onSelected: PropTypes.func.isRequired
}

const defaultProps = {
  options: [],
  label: '',
  initialValue: ''
}

const AutoComplete = ({ options, getOptionLabel, getOptionKey, label, initialValue, onSelected }) => {
  const [autoCompleteState, setAutoCompleteState] = useState({
    query: initialValue,
    filteredOptions: options,
    showOptions: false
  })

  useEffect(() => {
    setAutoCompleteState({ query: initialValue, filteredOptions: options, showOptions: false })
  }, [initialValue, options])

  const onChange = (event) => {
    setAutoCompleteState({
      query: event.target.value,
      filteredOptions: options.filter((option) => getOptionLabel(option).toLowerCase().includes((event.target.value).toLowerCase())),
      showOptions: true
    })
  }

  const { showOptions } = autoCompleteState

  return (
    <S.AutoCompleteContainer>
      <S.TextInput
        label={label}
        onChange={onChange}
        onFocus={() => setAutoCompleteState({ ...autoCompleteState, showOptions: true })}
        onBlur={() => {
          setAutoCompleteState({ ...autoCompleteState, showOptions: false })
        }}
        value={autoCompleteState.query}
      />
      <S.Icon className="icon-arrow-down2" />
      <S.DropdownOption {... { showOptions }}>
        { autoCompleteState.filteredOptions.map((option) => {
          return (
            <S.Option
              onMouseDown={(event) => { event.preventDefault() }}
              onClick={() => { onSelected(option); setAutoCompleteState({ ...autoCompleteState, showOptions: false }) }}
              key={getOptionKey(option)}
            >
              {getOptionLabel(option)}
            </S.Option>
          )
        })
        }
      </S.DropdownOption>
    </S.AutoCompleteContainer>
  )
}

AutoComplete.propTypes = propTypes

AutoComplete.defaultProps = defaultProps

export default AutoComplete

const S = {
  AutoCompleteContainer: styled.div`
  position:relative;
  `,
  TextInput: styled(TextInput)`
  `,
  Icon: styled.i`
  position: absolute;
  right:5px;
  color: ${color('dropdown')};
  top: 38px;
  `,
  DropdownOption: styled.div.withConfig({
    shouldForwardProp: (prop) => !['showOptions'].includes(prop)
  })`
    ${({ showOptions }) => showOptions
    ? css`
        display:block;
        position:absolute;
        max-height:300px;
        box-shadow: rgba(0,0,0,0.4) 0 2px 7px 0;
        width:100%;
        top:64px;
        z-index:1;
        padding:5px 0px;
        overflow: auto;
        border:1px solid ${color('border')};
        background:${color('paneBackground')}`
    : css`display:none`}
  `,
  Option: styled.div`
  padding:5px 10px;
  cursor: pointer;
  &:hover {
    background:${color('backgroundHover')}
  }
  `
}
